// eslint-disable-next-line jira/filename-case
import React, { useState, useCallback, type PropsWithChildren } from 'react';
import { createCtx } from '../utils/hooks/ctx.tsx';

export type ClickedArticleIds = string[];

export type FetchedArticleIds = string[];

export type QueryResults = {
	clickedArticleIds: ClickedArticleIds;
	fetchedArticleIds: FetchedArticleIds;
};
export interface SearchContextInterface {
	[query: string]: QueryResults;
}

export interface SearchContextProviderValue {
	searchContext: SearchContextInterface;
	addClickedArticleIds: (query: string, clickedArticleId: string) => void;
	addFetchedArticleIds: (query: string, fetchedArticles: string[]) => void;
}
const dest = createCtx<SearchContextProviderValue>();
export const useSearchContext: () => SearchContextProviderValue = dest[0];
export const CtxProvider: React.Provider<SearchContextProviderValue | undefined> = dest[1];

export const SearchContextProvider = ({ children }: PropsWithChildren<{}>): React.JSX.Element => {
	const [searchContext, setSearchContext] = useState<SearchContextInterface>({});

	const addClickedArticleIds = useCallback((query: string, clickedArticleId: string) => {
		setSearchContext((prev) => ({
			...prev,
			[query]: {
				...prev[query],
				clickedArticleIds: prev[query]?.clickedArticleIds
					? [...prev[query].clickedArticleIds, clickedArticleId]
					: [clickedArticleId],
			},
		}));
	}, []);

	const addFetchedArticleIds = useCallback((query: string, fetchedArticles: string[]) => {
		setSearchContext((prev) => ({
			...prev,
			[query]: {
				...prev[query],
				fetchedArticleIds: fetchedArticles,
			},
		}));
	}, []);

	return (
		<CtxProvider
			value={{
				searchContext,
				addClickedArticleIds,
				addFetchedArticleIds,
			}}
		>
			{children}
		</CtxProvider>
	);
};
